import { LegendaSimulado } from "../simulacao/legenda-simulado";
import { LegendSwatch } from "@/shared/components/legend-swatch";
import type { CargaLegendViewModel } from "./types-carga-legend";
import styles from "./carga-legend.module.scss";

export function CargaLegendView({
  testId,
  itens,
  mostraSimulado,
  simuladoPreenchido,
}: CargaLegendViewModel) {
  return (
    <ul className={styles.legend} aria-label="Legenda" data-testid={testId}>
      <li className={styles.legendTitle}>Legenda:</li>
      {itens.map((item) => (
        <li key={item.key} className={styles.legendItem}>
          <LegendSwatch kind={item.kind} />
          {item.label}
        </li>
      ))}
      {mostraSimulado ? (
        <LegendaSimulado
          className={`${styles.legendItem} ${styles.legendSimulado}`}
          preenchida={simuladoPreenchido}
        />
      ) : null}
      <li className={`${styles.legendItem} ${styles.legendToday}`}>
        <LegendSwatch kind="hoje" />
        Hoje
      </li>
    </ul>
  );
}
